import { addTraits } from 'src/api';

export const getInsurancePeople = state =>
  addTraits(state.insurance.insurancePeople);

export const getInsuranceLogs = state =>
  addTraits(state.insurance.insuranceLogs);
